import axios from "axios";

const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;

const CompositionService = {
    list: async (filters = {}) => axios.post(`${API_DESPACHO}/composition/list`, filters).then(({data}) => data.data).catch((err) => { throw err }),
    get: async (id) => axios.get(`${API_DESPACHO}/composition/${id}`).then(({data}) => data).catch((err) => { throw err }),
    vehicles: async () => axios.get(`${API_DESPACHO}/composition/vehicles`).then(({data}) => data).catch((err) => { throw err }),
    save: async (data) => axios.post(`${API_DESPACHO}/composition`, data).then(({data}) => data).catch((err) => { throw err }),
    update: async (id, data) => axios.put(`${API_DESPACHO}/composition/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(`${API_DESPACHO}/composition/${id}`).then(({data}) => data).catch((err) => { throw err }),
};

export default CompositionService;
